import { render, staticRenderFns } from "./IconPlacement.vue?vue&type=template&id=56dffb13&"
import script from "./IconPlacement.vue?vue&type=script&lang=ts&"
export * from "./IconPlacement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports